export function parseCookie(value: string): object { 
    const cookies = value.split(";");
    const result = {};
    cookies.forEach(function(cookie) {
        var pair = cookie.split("=");
        if (pair.length != 2) {
            console.debug(`Cannot parse ${cookie}. Key and value should be divided by =, and only one = sign should be met.`);
            return;
        }
        const key = pair[0];
        const value = pair[1];
        result[key.trim()] = value;
    });

    return result;
}
